import Nullstack from 'nullstack';
export default function IconWoman({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-woman",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M10 16v5"
  }), "   ", Nullstack.element("path", {
    d: "M14 16v5"
  }), "   ", Nullstack.element("path", {
    d: "M8 16h8l-2 -7h-4z"
  }), "   ", Nullstack.element("path", {
    d: "M5 11c1.667 -1.333 3.333 -2 5 -2"
  }), "   ", Nullstack.element("path", {
    d: "M19 11c-1.667 -1.333 -3.333 -2 -5 -2"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "4",
    r: "2"
  }), " ");
}